/**
 * @file   src\components\Introduction\ViewWantAdIntroductions.js
 * @brief  This file is responsible for the view of list of introductions introduced to a perticular want-ad in want ad details page right section.
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useRef } from "react";
import { pageURLs } from "@/constants";
import noImage from "../../images/no-image-small.png";
import {
  getpropertyName,
  getUserType,
  removeDecimalZeros,
  truncate,
} from "../../helpers/common";
import Button from "react-bootstrap/Button";
import { filterArray, thousandSeperatedValue } from "../../helpers/common";
import { IS_LAND, LOT_TYPES, USER_TYPE_AGENT } from "../../constants/common";
import { useNavigate } from "react-router-dom";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";

const ViewWantAdIntroductions = (props) => {
  const { list, updateIntroPageOnScroll, getIntroductionDetails, introCount } =
    props;
  // Navigate object creation.
  const navigate = useNavigate();
  // References
  const myRef = useRef(null);

  // To handle the introduction list section scroll
  const handleScroll = () => {
    const el = myRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      updateIntroPageOnScroll();
    }
  };

  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  if (shouldRestrictAgent) {
    return null;
  }

  return (
    <>
      <div className="ad-strengthen-wrap mb-0 mb-sm-4">
        <h6 className="strengthen-sub-head">
          Introduced to this want-listing (<span>{introCount}</span>)
        </h6>
        <div className="view-intro-wrap" onScroll={handleScroll} ref={myRef}>
          {list.map((intro, index) => {
            const askingPrice = _.get(intro, "AskingPrice", "");
            const lotType = _.get(intro, "LotType_Rural_City", "");
            const inventoryImage =
              _.get(intro, "Photo_1", "") !== "null" &&
              _.get(intro, "Photo_1", "") !== "undefined" &&
              _.get(intro, "Photo_1", "") !== null
                ? _.get(intro, "Photo_1", "")
                : noImage;
            const city = _.get(intro, "City", "")
              ? _.get(intro, "City", "")
              : "";
            const state = _.get(intro, "State", "")
              ? _.get(intro, "State", "")
              : "";
            const location = city + (state && ", " + state);
            return (
              <div
                className="add-your-property-wrap flex-column mb-4"
                key={index}
              >
                <div className="d-flex w-100 mb-3">
                  <div className="make-intro-img">
                    <img src={inventoryImage} alt={inventoryImage} />
                  </div>
                  <div className="make-intro-details pe-0">
                    <h3 className="mb-0 long-txt-fix">
                      {getpropertyName(intro)}{" "}
                      <span className="f-regular long-txt-fix">in</span>{" "}
                      {truncate(location, 20)}
                    </h3>

                    {_.get(intro, "PropertyTypeId", "") === IS_LAND ? (
                      <ul className="intro-list">
                        <li>
                          {" "}
                          {removeDecimalZeros(
                            _.get(intro, "TotalAcre", "")
                          )}{" "}
                          Acres
                        </li>

                        {lotType && (
                          <li>
                            <span>&bull;</span>
                            {filterArray(LOT_TYPES, "value", lotType)}
                          </li>
                        )}
                      </ul>
                    ) : (
                      <ul className="intro-list">
                        {_.get(intro, "Bedrooms", "") && (
                          <li>
                            {removeDecimalZeros(_.get(intro, "Bedrooms", ""))}{" "}
                            Beds
                          </li>
                        )}
                        {_.get(intro, "Bathrooms", "") && (
                          <li>
                            <span>&bull;</span>
                            {removeDecimalZeros(
                              _.get(intro, "Bathrooms", "")
                            )}{" "}
                            Baths
                          </li>
                        )}
                        {_.get(intro, "Sqft", "") && (
                          <li>
                            <span>&bull;</span>
                            {removeDecimalZeros(_.get(intro, "Sqft", ""))} sqft
                          </li>
                        )}
                      </ul>
                    )}
                    <div className="intro-amt">
                      ${askingPrice && thousandSeperatedValue(askingPrice)}
                    </div>
                    {_.get(intro, "IsExpired", "") == 1 && (
                      <div className="modal-wrap-label-orange mt-2 f-size-14">
                        Expired
                      </div>
                    )}
                  </div>
                </div>
                {_.get(intro, "IsExpired", "") != 1 && (
                  <div className="d-flex w-100">
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100 l-spacing-0"
                      onClick={() =>
                        getIntroductionDetails(
                          _.get(intro, "IntroductionId", ""),
                          _.get(intro, "IsAccept", "")
                        )
                      }
                    >
                      View Details
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <Button
          variant="primary"
          className="w-100 mb-0 mt-3 l-spacing-0"
          onClick={() => navigate(pageURLs.allIntroductions)}
        >
          View All
        </Button>
      </div>
    </>
  );
};
export default ViewWantAdIntroductions;
